<template>
    <div>
      <div v-for="ut in userTags" v-bind:key="ut.id" class="campaign">
        <small class="subtitle">{{ ut.name }}</small>
        <div class="tags-list">
          <div v-for="tag in ut.list" v-bind:key="tag.id">
            <b-badge :variant="tag.variant">
              <span>{{ tag.name }}</span>
              <b-button :id="'tooltip-target-' + tag.id">
                <i class="fa fa-info-circle fa-lg"></i>
              </b-button>
              <b-button v-if="tag.scheduledDate" :id="'tooltip-target-scheduledDate-' + tag.id" size="sm">
                <i class="fa fa-calendar-check-o fa-lg"></i>
              </b-button>
            </b-badge>
            <b-tooltip :target="'tooltip-target-' + tag.id" triggers="hover">
              <i class="fa fa-check-circle"></i> {{ ut.name }}<br/>
              <i class="fa fa-user-o"></i> {{ tag.creatorName }}<br/>
              <i class="fa fa-calendar-check-o"></i> {{ getFullDate(tag.date) }}<br/>
            </b-tooltip>
            <b-tooltip :target="'tooltip-target-scheduledDate-' + tag.id" triggers="hover">
              Data pgto: {{ tag.scheduledDate | moment-date}}
            </b-tooltip>
          </div>
        </div>
        <hr />
      </div>
    </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  data () {
    return {
      userTags: []
    }
  },
  mounted () {
    this.getCampaignsTags()
  },
  methods: {
    getFullDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    },
    getCampaignsTags () {
      this.$http.get(`api/transactions/${this.$route.params.txid}/tagsHistory`)
        .then(function (res) {
          this.userTags = res.data
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
        })
    }
  },
  watch: {
    '$route.params.txid' () {
      this.getCampaignsTags()
    }
  }
}
</script>

<style lang="scss" scoped>
  .campaign {
    margin: 10px 10px -16px 10px;

      .campaign-name {
        padding: 0.30em 0.7em;
        font-size: 85%;
      }
  }
  .tags-list {
   display: flex;
   flex-wrap: wrap;

    div {
      padding: 2px 3px;

        span {
          display: flex;
          align-items: center;
        }
    }

    .btn[class*="btn"] i {
      font-size: 13px !important;
      margin-right: 0px !important;
      margin-bottom: 1px;
    }

    .btn-secondary {
      font-size: 0px !important;
      color: inherit !important;
      background-color: inherit !important;
      border-color: inherit !important;
      outline: none !important;
      outline-color: inherit !important;
      border: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/tagCampaigns/UserCampaignsList.vue